import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { LanguageProvider } from './i18n/LanguageContext';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const theme = createTheme({
	palette: {
	  primary: {
		main: '#F0B21C',
		light: '#F4C757',
		dark: '#D69E0F',
		contrastText: '#fff',
	  },
	  secondary: {
		main: '#1976d2',
		light: '#42a5f5',
		dark: '#1565c0',
		contrastText: '#fff',
	  },
	},
	components: {
	  MuiButton: {
		styleOverrides: {
		  root: {
			borderRadius: '4px',
			fontWeight: 500,
			padding: '8px 20px',
			transition: 'all 0.3s ease',
			'&:hover': {
			  transform: 'translateY(-2px)',
			},
		  },
		  contained: {
			'&.MuiButton-containedPrimary': {
			  backgroundColor: '#F0B21C',
			  color: '#fff',
			  '&:hover': {
				backgroundColor: '#D69E0F',
			  },
			},
		  },
		  outlined: {
			'&.MuiButton-outlinedPrimary': {
			  borderColor: '#F0B21C',
			  color: '#F0B21C',
			  '&:hover': {
				borderColor: '#D69E0F',
				backgroundColor: 'rgba(240, 178, 28, 0.08)',
			  },
			},
		  },
		},
	  },
	  MuiIconButton: {
		styleOverrides: {
		  root: {
			transition: 'all 0.2s ease',
			'&:hover': {
			  transform: 'scale(1.1)',
			},
			'&.MuiIconButton-colorPrimary': {
			  color: '#F0B21C',
			  '&:hover': {
				backgroundColor: 'rgba(240, 178, 28, 0.08)',
			  },
			},
		  },
		},
	  },
	  MuiTextField: {
		styleOverrides: {
		  root: {
			'& label.Mui-focused': {
			  color: '#F0B21C',
			},
			'& .MuiInput-underline:after': {
			  borderBottomColor: '#F0B21C',
			},
			'& .MuiOutlinedInput-root': {
			  '&:hover fieldset': {
				borderColor: '#F0B21C',
			  },
			  '&.Mui-focused fieldset': {
				borderColor: '#F0B21C',
			  },
			},
		  },
		},
	  },
	  MuiAutocomplete: {
		styleOverrides: {
		  root: {
			'& label.Mui-focused': {
			  color: '#F0B21C',
			},
			'& .MuiInput-underline:after': {
			  borderBottomColor: '#F0B21C',
			},
			'& .MuiOutlinedInput-root': {
			  '&:hover fieldset': {
				borderColor: '#F0B21C',
			  },
			  '&.Mui-focused fieldset': {
				borderColor: '#F0B21C',
			  },
			},
		  },
		},
	  },
	  MuiChip: {
		styleOverrides: {
		  root: {
			'&.MuiChip-colorPrimary': {
			  backgroundColor: '#F0B21C',
			  color: '#fff',
			},
		  },
		},
	  },
	},
  });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<BrowserRouter basename="">
		<RecoilRoot>
			<LanguageProvider>
				<ThemeProvider theme={theme}>
					<App />
				</ThemeProvider>
			</LanguageProvider>
		</RecoilRoot>
	</BrowserRouter>
);

/*

	   </LanguageProvider>
*/